export default class User {
  public id: string
  public firstName: string
  public lastName: string
  public email: string
}


// WEBPACK FOOTER //
// ./src/modules/subscription/models/User.ts